import React from "react";
import Lottie from "lottie-web";
import Animation from "../../../../../static/animations/hero-zmt.json";

export default function HeroZmt() {
  React.useEffect(() => {
    Lottie.loadAnimation({
      container: document.querySelector("#hero-animation-bg"),
      animationData: Animation,
      renderer: "svg", // "canvas", "html"
      loop: true, // boolean
      autoplay: true, // boolean
    });
  }, []);

  return (
    <>
      <div id="hero-animation-bg" />
      <div id="coin-zmt" />
    </>
  );
}
